import React, { useEffect, useState, useContext } from "react";
import { Card, Nav } from "react-bootstrap";
import { Link } from 'react-router-dom';
//import '../../styles/admin.css'
import { useLocation } from 'react-router-dom';
import { getPagesByLang } from "../admin/apiCalls";
import { store, StateProvider } from '../../Store';

const ObservatorySidebar = props => {
  const currentLocation = useLocation();
  
  const { state, dispatch } = useContext(store);

  const [pagesList, setPagesList] = useState([]);

  const styleTheme = {
    'navbar': `${state?.configData && state.configData.theme}-navbar`,
    'active': `${state?.configData && state.configData.theme}-active`
  }

  const refreshList = () => {
    getPagesByLang( 'es', (response) => {
      setPagesList(JSON.parse(response));
    });
  }  

  useEffect( refreshList, 'es');

  return (
    <>
      <Card >
      <Nav defaultActiveKey="/home" className={ "flex-column admin-sidebar " + styleTheme.navbar }>
        {/*<Link to={`/observatory`} className={currentLocation.pathname === `/observatory/` && 'active ' + styleTheme.active}>Observatorio de datos</Link>*/}
        {
        pagesList.map((item) => {
          return (<Link to={`/observatory/${item.code}`} className={currentLocation.pathname === `/observatory/${item.code}` && 'active ' + styleTheme.active}>{ item.title }</Link>)
        })
        }
      </Nav>
      </Card>
    </>
  );
  
}

export default ObservatorySidebar;